import { Button, Result } from "antd-mobile";
import { useNavigate } from "react-router-dom";

export default function () {
    const navigate = useNavigate();

    setTimeout(() => navigate("../leaveRequestWait",{replace: true}),5000)
    return (
        <div
            style={{
                display: "flex",
                height: "100vh",
                flexDirection: "column",
            }}
        >
            <div style={{ flex: 1, display: "flex", placeItems: "center", placeContent: "center" }}>
                <Result
                    status="waiting"
                    title="Richiesta inviata correttamente"
                    description="Riceverai un messaggio o una email di aggiornamento"
                    style={{
                        "--adm-font-size-10": "35px",
                        "--adm-font-size-main": "25px",
                    }}
                />
            </div>
            <div style={{ padding: 36 }}>
                <Button
                    block
                    color="primary"
                    size="large"
                    onClick={() => navigate("../leaveRequestWait", { replace: true })}
                >
                    Chiudi
                </Button>
            </div>
        </div>
    );
}
